export const ROLE_NAME_MAP: Record<string, string> = {
  PPP: "Program Point Person",
  FPP: "Finance Point Person",
  LEGAL: "Legal",
  PD: "Country Program Director",
  ED: "Executive Director",
  TECHNICAL: "Technical Teams",
  IMPACT: "Impact And Research",
  POP: "Program Ops And Planning",
  PARTNER: "Contracted Partner",
  CHIEFS: "Chiefs",
};

export const WIDGET_NAME_MAP: Record<string, string> = {
  "dashboard.quiklinks": "Quick Links",
  "dashboard.settings": "Settings",
  "dashboard.myactiveitems": "My Active Items",
  "dashboard.taskpriorities": "Task Priorities",
  "dashboard.keyguidelines": "Key Guidelines",
  "dashboard.upcomingmeetings": "Upcoming Meetings",
  "dashboard.impacttargets": "Impact Targets",
  "dashboard.teamcalender": "Team Calendar",
  "dashboard.partnerdirectory": "Partner Directory",
  "dashboard.learninginsights": "Learning Insights",
  "dashboard.analyticsinsights": "Analytics Insights",
  "dashboard.compas": "Compass",
  "dashboard.programresources": "Program Resources",
  "dashboard.notifications": "Notifications",
  "dashboard.oversight": "Oversight",
  "dashboard.submissions": "Submissions",
  "dashboard.programmetrics": "Program Metrics",
  "dashboard.partnerissuesrisks": "Partner Issues & Risks",
  "dashboard.paymentspipeline": "Payments Pipeline",
  "dashboard.partnersubmissions": "Partner Submissions",
  "dashboard.disbursementrequest": "Disbursement Request",
  "dashboard": "Dashboard"
};

export const WIDGET_CODE_MAP: Record<string, string> = Object.fromEntries(
  Object.entries(WIDGET_NAME_MAP).map(([key, value]) => [value, key])
);